import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import MigrantesCard from "../../molecules/migrantes-card/migrantesCard";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

// Components
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

//Styles
import "./FormMigrantes.scss";

const FormMigrantes = () =>{
    
    const data = useStaticQuery(graphql`
        query contentfulFormMigrantes {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "5WIJT48BCvkx07EWODyk2N" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            textoTerminosMigrantes {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                            placeholder
                        }
                        tituloBoton
                    }
                    imagenesEmpleo {
                        file {
                            url
                            details {
                                image {
                                    height
                                    width
                                }
                            }
                        }
                    }
                    imagenFormulario {
                        file {
                            details {
                                image {
                                    width
                                    height
                                }
                            }
                            url
                        }
                    }
                    tituloUbicacion
                    redireccionBoton
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "5UGNfT31HEAV5jPkTSaMnp" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    descripcionFormulario {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalRegistered: allContentfulContactenos(
                filter: { contentful_id: { eq: "6cVU3tkD0arfaCPwV1Abxu" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalCancelar: allContentfulContactenos(
                filter: { contentful_id: { eq: "5sSYZh2HHC69sLQEbpSqM" } }
            ) {
                nodes {
                    tituloPrincipal
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
            modalDeshabilitar: allContentfulContactenos(
                filter: { contentful_id: { eq: "5s4JlTGQ0JZ2SF1zgpf72w" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    formularioMigrantesActivo
                    fechaInicioConvocatoriaMigrantes
                    fechaFinConvocatoriaMigrantes
                }
            }
            modalEdad: allContentfulContactenos(
                filter: { contentful_id: { eq: "7ujErH72yd86qhkF08NbKM" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    formularioMigrantesActivo
                }
            }
        }
    `);
    
    const contentfulData = data.form.nodes[0];
    const contentfulModalSuccess = data.modalSuccess.nodes[0];
    const contentfulModalRegistered = data.modalRegistered.nodes[0];
    const contentfulModalCancelar = data.modalCancelar.nodes[0];
    const contentfulModalDeshabilitar = data.modalDeshabilitar.nodes[0];
    const contentfulModalEdad = data.modalEdad.nodes[0];
    
    const { isBrowser, window } = useBrowserMode();
    const [pathname, setPathname] = useState("");

    useEffect(() => {
        const getPathname = () => {
            if(isBrowser) {
                if (window.location.pathname.includes("personas")) {
                    setPathname("Personas")
                }
            }
        }

        getPathname();
    }, [])

    return (
        <>
            <div className="m-form-migrantes">
                <div className="m-breadcrumb">
                    <Breadcrumb content={ `Inicio / ${pathname} / ${contentfulData.tituloPrincipal}` } />
                </div>
                <>
                    <MigrantesCard 
                        tituloPrincipal={contentfulData.tituloPrincipal}
                        tituloFormulario={contentfulData.tituloFormulario}
                        descripcionFormulario={
                            JSON.parse(contentfulData.descripcionFormulario.raw)
                        }
                        tituloUbicacion={contentfulData.tituloUbicacion}
                        titulosFormulario={contentfulData.titulosFormulario}
                        metaTitulo={contentfulData.metaTitulo}
                        modalSuccess={contentfulModalSuccess}
                        modalRegistered={contentfulModalRegistered}
                        modalCancelar={contentfulModalCancelar}
                        modalDeshabilitar={contentfulModalDeshabilitar}
                        pathSharepoint={contentfulData.redireccionBoton}
                        modalEdad={contentfulModalEdad}
                    />
                </>
            </div>
        </>
    );
};

export default FormMigrantes;
